import { Fragment } from 'react';
import Link from 'next/link';
import { RightOutlined } from '@ant-design/icons';
import { Col, Grid, Row } from 'antd';
import layoutMobile from 'src/utils/layout-mobile';

import ButtonC from '../Forms/Button';
import cn from "src/utils/cn";

type Props = {
	router: any;
	backgroundImage: string;
	buttonColor?: string;
	buttonText: any;
	name: string[];
	description?: string;
	onClick?: () => void;
	isTextShadow?: boolean;
	title?: string;
	breadcrumbs?: any;
	mobileBackground?: string;
};

const BannerHeader = (props: Props) => {
	const { xxl, lg, xl, xs } = Grid.useBreakpoint();
	const {
		router,
		backgroundImage,
		buttonColor,
		name,
		description,
		onClick,
		buttonText,
		mobileBackground,
	} = props;
	const lm = layoutMobile(router);

	return (
		<>
			<Row
				style={{
					backgroundImage:
						xs && mobileBackground ? `url("${mobileBackground}")` : `url("${backgroundImage}")`,
				}}
				className="bg-no-repeat bg-cover bg-center flex justify-center items-start h-[298px] sm:h-[34vw] pt-[15px] sm:pt-2.5 xl:pt-10"
			>
				<Col className="container">
					{!lm && (
						<Row gutter={8}>
							<Col xs={24}>
								<h1 className="!text-white m-0 font-semibold text-lg leading-[140%] sm:font-bold sm:text-xl sm:mb-[3px] lg:text-2xl lg:leading-8 lg:mb-[19px]">
									{props.title}
								</h1>
								{/* <Text className="text-neutral-5">{props.description}</Text> */}
							</Col>
						</Row>
					)}
					{!lm && props.breadcrumbs && (
						<div className="flex items-center gap-x-[7px] text-xs pt-4 pb-[30px] px-0 mb-0 sm:gap-x-[13px] sm:pt-0 sm:pb-0 lg:text-sm lg:mb-[37px]">
							<Link href="/" className="text-white hover:underline font-normal text-xs lg:text-sm leading-[150%]">
								Home
							</Link>

							{props.breadcrumbs?.map((item: any, i: number) => {
								if (item.navigatePath) {
									return (
										<Fragment key={i}>
											<RightOutlined className="text-white [&>svg]:text-white [&>svg]:text-[11px] [&>svg]:h-[10px] lg:[&>svg]:text-[13px] lg:[&>svg]:h-auto" />
											<Link href={item.navigatePath} className="text-white hover:underline font-normal text-xs lg:text-sm leading-[150%]">
												{item.label}
											</Link>
										</Fragment>
									);
								}

								return (
									<Fragment key={i}>
										<RightOutlined className="text-white [&>svg]:text-white [&>svg]:text-[11px] [&>svg]:h-[10px] lg:[&>svg]:text-[13px] lg:[&>svg]:h-auto" />
										<span key={item.label} className="text-white font-normal text-xs lg:text-sm leading-[150%]">
											{item.label}
										</span>
									</Fragment>
								);
							})}
						</div>
					)}
					<div
						className={cn('max-w-[712px] mb-[5px] lg:mb-5', {
							'mt-[50px] sm:mt-7.5 lg:mt-10': lm,
						})}
					>
						{name.map((item, index) => (
							<h2
								style={props.isTextShadow ? { textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' } : {}}
								className="text-white tracking-normal text-left mb-0 font-semibold text-lg leading-[140%] sm:font-bold sm:text-2xl sm:leading-8 sm:mt-0 md:leading-10 md:mt-2.5 lg:text-[38px] lg:leading-[47px] lg:mt-0"
								key={index}
							>
								{item}
							</h2>
						))}
					</div>
					<h3 className="text-white font-semibold text-left tracking-[0.15px] text-xs leading-normal mt-3.5 mb-3 sm:text-sm sm:leading-[18px] sm:mt-0 sm:mb-3 lg:text-base lg:leading-[21px] lg:mb-4">
						{description}
					</h3>
					<ButtonC
						style={{
							background: buttonColor ?? '#00a376',
							border: buttonColor ?? '#00a376',
							color: '#FDFDFE',
						}}
						className={`${xxl || lg || xl ? 'w-[343px] h-12' : ''} hover:!opacity-70 hover:bg-white`}
						size="large"
						text={buttonText}
						onClick={onClick}
					></ButtonC>
				</Col>
			</Row>
		</>
	);
};

export default BannerHeader;
